export default {
  "content": "<circle cx=\"18\" cy=\"18\" r=\"16\" fill=\"#3F4450\" stroke=\"#fff\" stroke-width=\"4\"/><path d=\"M10 26v-1.28h3.2v-3.84h3.84v-3.84h3.84V13.2h3.84V10H26v4.48h-3.84v3.84h-3.84v3.84h-3.84V26H10z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};